import { useCallback, useMemo, useState } from 'react';

export const useFetchTelemetry = () => {
  const [fetchTelemetry, setFetchTelemetry] = useState([]);

  const resetFetchTelemetry = useCallback(() => {
    setFetchTelemetry([]);
  }, []);

  const captureFetchTelemetry = useCallback((entry) => {
    setFetchTelemetry((current) => [entry, ...current].slice(0, 25));
  }, []);

  const partialIssues = useMemo(() => {
    const byEndpoint = new Map();

    fetchTelemetry.forEach((entry) => {
      const isIssue = entry.fallbackActivated || entry.timedOut || entry.status === 'error';
      if (!isIssue) return;
      if (!byEndpoint.has(entry.endpoint)) {
        byEndpoint.set(entry.endpoint, entry);
      }
    });

    return Array.from(byEndpoint.values());
  }, [fetchTelemetry]);

  return {
    fetchTelemetry,
    partialIssues,
    captureFetchTelemetry,
    resetFetchTelemetry,
  };
};